import React, { useEffect, useState } from 'react';
import ChatV1 from './v1/ChatAssistantWrapper';
import ChatV0 from './v0/ChatAssistantWrapper';
import ChatV2 from './v2/ChatAssistantWrapper';
import ChatV2Simple from './v2/ChatAssistantWrpperSimple';
import { fetchSysConfig } from '../services/api/KaiConfigData';

const ChatVersionWrapper: React.FC = () => {
  const [DynamicComponent, setDynamicComponent] = useState<React.ComponentType<any> | null>(null);

  useEffect(() => {
    const loadVersion = async () => {
      try {
        const res = await fetchSysConfig();
        console.log('fetchSysConfig response:', res);
        const dt: { id: string; val: string }[] = res.data;
        console.log('Config data:', dt);
        
        // Try multiple field names to be safe
        let version = dt.find(item => item.id === 'uichat_version')?.val ?? 
                     dt.find(item => item.id === 'uichat_version')?.val ?? 'v1';
        version = 'v2'
        console.log('Detected version:', version);

        if (version === 'v0') {
          console.log('Loading v0 component');
          setDynamicComponent(() => ChatV0);
        } else if (version === 'v2') {
          console.log('Loading v2 component');
          setDynamicComponent(() => ChatV2);
        } else {
          console.log('Loading v1 component (default)');
          setDynamicComponent(() => ChatV1);
        }
      } catch (err) {
        console.error('Error in loadVersion:', err);
        // Fallback to v1 on error
        console.log('Falling back to v1 due to error');
        setDynamicComponent(() => ChatV1);
      }
    };

    loadVersion();
  }, []);

  if (!DynamicComponent) return <div>Loading...</div>;

  return <DynamicComponent />;
};

export default ChatVersionWrapper;
